export const EffectType = {
    /**
     * @constant
     * @type {number}
     */
    SPRITE_EFFECT: 0,
    /**
     * @constant
     * @type {number}
     */
    LIGHTNING_EFFECT: 1,
    /**
     * @constant
     * @type {number}
     */
    AREA_EFFECT: 2
    // /**
    //  * @constant
    //  * @type {number}
    //  */
    // PATH_EFFECT: 3
}